import { Link } from "react-router-dom";
import { PageHeader } from "@/components/Shared";
import { WeightsCard } from "@/components/WeightsCard";
import { TemplateCard } from "@/components/TemplateCard";
import { MenuAccessCard } from "@/components/MenuAccessCard";
import { LayoutOrderCard } from "@/components/LayoutOrderCard";
import { AllowedUnitsCard } from "@/components/AllowedUnitsCard";

export default function SettingsPage() {
  return (
    <div className="space-y-6 px-4 py-6 sm:px-6 lg:px-8">
      <PageHeader eyebrow="Administrasi" title="Pengaturan" desc="Akses menu per peran, bobot penilaian peringkat unit, dan template laporan PPT." />
      <MenuAccessCard />
      <WeightsCard />
      <LayoutOrderCard />
      <AllowedUnitsCard />
      <TemplateCard />
      <p className="text-sm text-muted-foreground">Link Google Sheet sumber data diatur di halaman <Link data-testid="settings-sync-link" to="/sync" className="font-semibold underline">Sinkronisasi</Link>.</p>
    </div>
  );
}
